let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jv5OL")).then(() => parcelRequire('fyj1u'));